var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useContext } from 'react';
import { DrawerContext } from './DrawerContext';
export const useDrawer = () => {
    _react_refresh_temp_1();
    const drawerContextValue = useContext(DrawerContext);
    if (!drawerContextValue) {
        throw new Error('Drawer context not available!');
    }
    return drawerContextValue;
};
_react_refresh_temp_1(useDrawer, "JnNo7p2uB7XBH0AsXx/ZKdsFhXU=");
